import { render, staticRenderFns } from "./BaseFab.vue?vue&type=template&id=ff7df972&scoped=true&"
import script from "./BaseFab.vue?vue&type=script&lang=js&"
export * from "./BaseFab.vue?vue&type=script&lang=js&"
import style0 from "./BaseFab.vue?vue&type=style&index=0&id=ff7df972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7df972",
  null
  
)

export default component.exports